import React, { useState } from "react";
import { faFileCirclePlus } from "@fortawesome/free-solid-svg-icons";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
//import { faFilePdf } from "@fortawesome/free-regular-svg-icons";
import { Box, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { adobeColor, exportColor, iconSize } from "../../App/GridRenderers";
import { pdfGenerateStart } from "./Generate.jsx";
import { PdfBuilder } from "./Build.jsx";
// import { pdfBuilder } from "./Build.jsx";


export const PdfExport = ({ clientJson, name }) => {
    const [show, setShow] = useState(false);

    const onPdfDownload = () => {
        pdfGenerateStart(clientJson)
    }


    return (
        <>
            {/* <Box sx={{ pt: 1 }}>
                <Tooltip title="Download a PDF file of the scenario"
                    enterDelay={1000}>
                    <FontAwesomeIcon
                        icon={faFilePdf}
                        onClick={onPdfDownload}
                        size={iconSize}
                        color={adobeColor}
                    />
                </Tooltip>
            </Box> */}
        </>
    );
};


export const PdfBuild = ({ clientJson, preparedBy, executedDate }) => {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);


    return (
        <>
            <Box sx={{ pt: 1 }}>
                <Tooltip title="Setup and download PDF report of the scenario"
                    enterDelay={1000}>

                    <FontAwesomeIcon
                        icon={faFilePdf}
                        onClick={handleShow}
                        size={iconSize}
                        color={adobeColor}
                    />
                </Tooltip>
            </Box>
            <PdfBuilder
                show={show}
                clientJson={clientJson}
                onClose={handleClose}
                preparedBy={preparedBy}
                executedDate={executedDate}
            />
        </>
    );
};